<div class="d-flex flex-column mx-3 flex-fill">
  <div class="d-flex justify-content-between">
    <label for="fittingType" class="form-label text-nowrap">{{label}}</label>
    <div *ngIf="isRequired" class="form-text text-danger"><i class="fa fa-asterisk me-2"></i>Required</div>
  </div>
  <ng-content></ng-content>
  <small *ngIf="errorOutput.length > 0" class="text-danger errors">
    <span class="me-1" *ngFor="let err of errorOutput">
      <i class="fa fa-exclamation-triangle me-1"></i>
      <span class="mx-1">{{err}}</span>
    </span>
  </small>
</div>
